import { ReactNode } from 'react';
import { TopHeaderWrapper } from './styles';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { Box } from '@/components/Box/Box';
import { NotificationsBell } from '@/bundle/shared/components/NotificationsBell/NotificationsBell';
import { UserPopoverMenu } from './ui/UserPopoverMenu/UserPopoverMenu';
import { useUser } from '@/context/userContext';
import { getOrganizationName } from '@/helpers/userHelpers';

type TopHeaderType = {
  breadcrumbs: ReactNode;
};

export const TopHeader = ({ breadcrumbs }: TopHeaderType) => {
  const { isAdminRole, user } = useUser();
  const organizationName = getOrganizationName(user);
  const showOrganizationName = isAdminRole && !!organizationName;

  return (
    <TopHeaderWrapper>
      {showOrganizationName && (
        <Typography variant='bodySmall' color={COLORS.grey[650]} textTransform='uppercase'>
          {organizationName} {':'} &nbsp;
        </Typography>
      )}
      <Typography variant='bodySmall' color={COLORS.grey[650]}>
        {breadcrumbs}
      </Typography>
      <Box display='flex' alignItems='center' marginLeft='auto' gap='24px'>
        {isAdminRole && <NotificationsBell />}
        <UserPopoverMenu />
      </Box>
    </TopHeaderWrapper>
  );
};
